import { RootPaths } from "@src/appV2/App/paths";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import { SHIFT_DISCOVERY_LIST_PATH } from "../../ShiftDiscovery/paths";
import { ScreeningSurveyInfoLayout } from "./components/ScreeningSurveyInfoLayout";

interface ScreeningSurveyWelcomeProps {
  onGetStarted: () => void;
}

export function ScreeningSurveyWelcome(props: ScreeningSurveyWelcomeProps) {
  const { onGetStarted } = props;
  const history = useHistory();

  return (
    <ScreeningSurveyInfoLayout
      title="Welcome!"
      icon="house-illustration"
      action={{ label: "Get Started", onClick: onGetStarted }}
      onBack={() => {
        history.replace(`${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}`);
      }}
    >
      <Text
        variant="h4"
        sx={(theme) => ({ textAlign: "center", color: theme.palette.text.secondary })}
      >
        Please fill out this less than 1 minute form to apply for Home Health & Hospice
        opportunities.
      </Text>
    </ScreeningSurveyInfoLayout>
  );
}
